import {MatterDocument} from "common/types/matter";

export default function isMatterDocumentComplete(document: MatterDocument) {
  return [2, 3].includes(document.load_state);
}
